import styled, { css } from 'styled-components';
import { theme } from 'modules/tetrisTheme';
import { linkAppearance } from './utils';
const fontSize = {
    large: theme.fontSize.large,
    medium: theme.fontSize.medium,
    small: theme.fontSize.small,
    tiny: theme.fontSize.tiny,
};
const linkBase = css `
  font-size: ${(props) => fontSize[props.$size]};
  display: inline-block;
  text-decoration: none;
  cursor: pointer; /* required for <Link as="button"> */
`;
export const StyledAnchor = styled.a `
  ${linkBase};

  ${(props) => linkAppearance(props.$appearance)};
`;
